import { render, staticRenderFns } from "./CompanyGroupForm.vue?vue&type=template&id=644e9cce&"
import script from "./CompanyGroupForm.vue?vue&type=script&lang=js&"
export * from "./CompanyGroupForm.vue?vue&type=script&lang=js&"
import style0 from "./CompanyGroupForm.vue?vue&type=style&index=0&id=644e9cce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports